import React from "react";
import Icon from 'components/Safra/Icon';
import { useNavigate } from "react-router-dom";

import Button from "components/Button";
import { useTranslation } from "contexts/Safra/TranslationContext";

export default function FilterHotels({ order, handleApplyOrder }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleChangeOrder = (event) => {
        handleApplyOrder(event.target.value);
    };

    const handleGoToFilterScreen = () => {
        navigate("/hotels-filter");
    };

    return (
        <div className="row align-items-end">
            <div className="col-7 d-flex gap-2">
                <Button outline={true} width="100px" onClick={handleGoToFilterScreen}>
                    <Icon name="filter" /> {t('safra.hotel_search_result.filters.button')}
                </Button>
            </div>

            <div className="col-5">
                <select
                    className="form-select form-select-custom border-custom float-end"
                    value={order}
                    onChange={handleChangeOrder}
                >
                    <option value="">{t('safra.hotel_search_result.sorting.label')}</option>
                    <option value="az">A-Z</option>
                    <option value="za">Z-A</option>
                    <option value="asc_price">{t('safra.hotel_search_result.sorting.price_asc')}</option>
                    <option value="desc_price">{t('safra.hotel_search_result.sorting.price_desc')}</option>
                    <option value="stars">{t('safra.hotel_search_result.sorting.stars_desc')}</option>
                </select>
            </div>
        </div>
    );
}
